<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <strong>Name: </strong>{{data.name}}<br>
        <strong>Leave Type: </strong>{{data.concept}}<br>
        <strong>Date from: </strong>{{data.date1}}<br>
        <strong>Date to: </strong>{{data.date2}}<br>
        <strong>Reason: </strong>{{data.reason}}<br>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button *ngIf="data.confirmText === 'Approve'" mat-button class="approve-button"
            (click)="approveLeave(data.id)" cdkFocusInitial>{{data.confirmText}}</button>
        <button *ngIf="data.confirmText === 'Reject'" mat-button class="delete-button" (click)="declineLeave(data.id)"
            cdkFocusInitial>{{data.confirmText}}</button>
    </div>
</div>